export type VersionNumber = `${number}.${number}.${number}`;

export namespace VersionNumber {
  export function compare(a: VersionNumber, b: VersionNumber): number {
    if (!/^\d+\.\d+\.\d+$/.test(a) || !/^\d+\.\d+\.\d+$/.test(b)) return 0;
    const splitA = a.split('.').map(Number);
    const splitB = b.split('.').map(Number);
    if (
      splitA.length !== 3 ||
      splitB.length !== 3 ||
      [...splitA, ...splitB].some((part) => !Number.isSafeInteger(part) || part < 0)
    )
      return 0;

    for (let i = 0; i < 3; i++) {
      const difference = splitA[i] - splitB[i];
      if (difference !== 0) return difference;
    }
    return 0;
  }
}

export class VersionInfo {
  public number: VersionNumber = '0.0.0';
  public date: Date = new Date();
  public description: string = '';
  public major: boolean = false;

  public static compare(a: VersionInfo, b: VersionInfo): number {
    const value = b.date.getTime() - a.date.getTime();

    if (value === 0) {
      return VersionNumber.compare(b.number, a.number);
    }
    return value;
  }

  public static mapTo(v: any): VersionInfo {
    return {
      number: v.number,
      date: new Date(v.date),
      description: '',
      major: !!v.major
    };
  }
}
